export const incomingCampaignsCategories = ['pending_campaigns','upcoming_campaigns', 'running_campaigns', 'completed_campaigns'];
export const regulatorIncomingCampaignsCategories = ['upcoming_campaigns', 'running_campaigns', 'completed_campaigns'];
